import React from 'react';
import styled from 'styled-components';
import Hero from '../components/sections/Hero';
import AboutSection from '../components/sections/AboutSection';
import ProjectsSection from '../components/sections/ProjectsSection';
import MatrixBackground from '../components/animations/MatrixBackground';

const HomePage = () => {
  return (
    <MatrixWrapper>
      <MatrixBackground />
      <Hero />
      <AboutSection />
      <ProjectsSection />
    </MatrixWrapper>
  );
};

const MatrixWrapper = styled.div`
  position: relative;
  overflow: hidden;
`;

export default HomePage;